import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import { useParams } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import httpService from "../../../services/httpServices/httpServices";
import validateFormRole from "../../../validtions/forms/role/edit";

function EditRole() {
  const history = useHistory();
  const initRole = {
    name: "",
    persian_name: "",
  };
  const [message, setMessage] = useState();
  const [permissions, setPermissions] = useState();
  const [role, setRole] = useState(initRole);
  const params = useParams();
  const roleID = params.id;

  useEffect(() => {
    getRole().then((permissions) => {
      setAllPermissions(permissions);
    });
  }, []);

  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  const getRole = async () => {
    const role = await sendRequestGetRole(roleID);
    if (!role) {
      return;
    }

    setRole({
      name: role.rol_name,
      persian_name: role.rol_persian_name,
    });
    return await getPermissionsRole(roleID);
  };

  const getPermissionsRole = async (roleID) => {
    const headersRequest = getHeaderForRequset();
    let permissions;
    try {
      permissions = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/role/permission/" + roleID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return permissions.data.data;
  };

  const setAllPermissions = async (permissionsActive) => {
    let permissions = await getPermissions();
    setPermissions(generateTagPermissions(permissions, permissionsActive));
  };

  const getPermissions = async () => {
    const headersRequest = getHeaderForRequset();
    let permissions;
    try {
      permissions = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/permission",
        headersRequest
      );
    } catch (error) {
      alert("مشکلی در دریافت دسترسی ها بوجود آمده است.");
      return;
    }

    return permissions.data.data;
  };

  const generateTagPermissions = (permissions, permissionsActive) => {
    return permissions.map((permission, index) => {
      let isChecked = "";

      if (permissionsActive.indexOf(permission.per_id) !== -1) {
        isChecked = "checked";
      }

      let permissionTag = (
        <div className="col-12 col-sm-6 col-md-4">
          <span
            key={index}
            className="w-100 justify-content-between d-inline-flex align-items-center py-2"
          >
            <span className="small font-weight-bold text-nowrap">
              {permission.per_persian_name}
            </span>

            <span>
              <label className="adl-switch">
                <input
                  type="checkbox"
                  defaultChecked={isChecked}
                  value={permission.per_id}
                  className="permissions"
                />
                <span className="adl-slider round"></span>
              </label>
            </span>
          </span>
        </div>
      );

      return permissionTag;
    });
  };

  const sendRequestGetRole = async (roleID) => {
    const headersRequest = getHeaderForRequset(roleID);
    let role;
    try {
      role = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/role/" + roleID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return role.data.data;
  };

  const getHeaderForRequset = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getFormData = () => {
    const name = document.getElementById("name").value;
    const persianName = document.getElementById("name-persian").value;
    const checkeBoxes = document.querySelectorAll(".permissions:checked");
    let permissions = [];
    checkeBoxes.forEach((checkeBox) => {
      permissions.push(checkeBox.defaultValue);
    });

    return {
      name: name,
      persian_name: persianName,
      permissions: permissions,
    };
  };

  const sendFromEditRole = async (e) => {
    e.preventDefault();
    const formData = getFormData();
    if (validateFormRole(formData) != true) {
      setMessage({
        type_class: "alert alert-danger",
        text: validateFormRole(formData),
        class_icon: "fa fa-exclamation-triangle",
      });

      return;
    }

    const result = await sendRequestUpdateRole(formData);
    if (result) {
      history.push("/roles/all");
    }
  };

  const sendRequestUpdateRole = async (formData) => {
    const headersRequest = getHeaderForRequset();

    try {
      await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/role/" + roleID,
        formData,
        headersRequest
      );
    } catch (error) {
      setMessage({
        type_class: "alert alert-danger",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    return true;
  };

  return (
    <>
      <Sidebar openItem="role-permission" />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">ویرایش نقش</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              {messageTag}
              <form onSubmit={sendFromEditRole}>
                <div className="form-group">
                  <label>نام انگلیسی</label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    defaultValue={role.name}
                  />
                </div>
                <div className="form-group">
                  <label>نام فارسی</label>
                  <input
                    type="text"
                    className="form-control"
                    id="name-persian"
                    defaultValue={role.persian_name}
                  />
                </div>

                <div className="form-group mb-0">
                  <label>دسترسی ها</label>
                </div>
                <div className="  alert alert-secondary   p-2">
                  <div className="form-group">
                    <div className="container-fluid">
                      <div className="row">{permissions}</div>
                    </div>
                  </div>
                </div>
                <button type="submit" className="btn btn-outline-primary">
                  ارسال
                </button>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default EditRole;
